import { useCallback } from 'react';

import { type Library, type LibraryMember } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackLeaveLibrary.meta';

export type UseTrackLeaveLibraryParams = {
  library_id: Library['id'];
  library_member_id?: LibraryMember['id'];
};

export const useTrackLeaveLibrary = () => {
  const { track } = useAnalyticsUtilities();

  const trackLeaveLibrary = useCallback(
    (params: UseTrackLeaveLibraryParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackLeaveLibrary };
};
